import LiveClientRoomForDoctor from "./LiveClientRoomForDoctor";
export default LiveClientRoomForDoctor;
